import React, { useRef, useState, useEffect, act, useMemo } from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import {
  ClearSeekFlag,
  LoadVideoUrl,
  SetControllerToggle,
  SetVideoControl,
  UpdateVideoTime,
} from "../redux/actions/controlAction";
import { connect, useSelector } from "react-redux";
import VideoPlayer from "../components/VideoPlayerOld";
import {
  Text,
  TextInput,
  TouchableOpacity,
  useWindowDimensions,
} from "react-native";
import screenfull from "screenfull";
import { findDOMNode } from "react-dom";
import { AiOutlineFullscreen } from "react-icons/ai";
import { IoMdVolumeOff, IoMdVolumeHigh } from "react-icons/io";
import { Tooltip, Box } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  FaPause,
  FaPlay,
  FaArrowRight,
  FaStopwatch,
  FaSearch,
  FaEdit,
  FaVideo,
  FaCheckCircle,
  FaExclamationCircle,
  FaCheck,
  FaTimes,
  FaBell,
  FaArrowLeft,
  FaAngleDown,
  FaAngleUp,
} from "react-icons/fa";
import Duration from "../components/VideoPlayer(new)/DurationOld";
import {
  fetchMatchStringById,
  getReviewerFeedbackStrings,
  saveReviewerFeedback,
  updateMatchStatus,
} from "../config/mainRequest";

import { useHistory, useParams } from "react-router-dom";
import Logo from "../assets/Logo";
import toast, { useToasterStore } from "react-hot-toast";
import { CircularProgress, IconButton, Stack, Typography } from "@mui/material";
import { ArrowBack, Fax } from "@mui/icons-material";
import { v4 as uuidv4 } from "uuid";
import { FlatList, View } from "react-native-web";
import { useQuery } from "react-query";
import { AutoSizer, CellMeasurer, List } from "react-virtualized";
import { CellMeasurerCache } from "react-virtualized";
import { EVENT_MAP } from "../constant/positionList";
import { trackEvent } from "../utils/mixpanel";

const ReviewPortal = (props) => {
  const { UpdateVideoTime, SetVideoControl, videoUrl, all_matches } = props;
  const { matchId } = useParams();
  const matchDetails = props.all_matches.find(
    (match) => String(match.id) === String(matchId)
  );
  const reviewerId = matchDetails?.reviewer_details[0]?.id;

  const matchAnalystId =
    matchDetails?.analyst_details[matchDetails?.analyst_details.length - 1]?.id;

  const { analystId, token } = useSelector((state) => ({
    analystId: state.auth.analyst_id,
    token: state.auth.token,
  }));

  const [playing, setPlaying] = useState(false);
  const [ready, setReady] = useState(false);
  const [layoutWidth, setLayoutWidth] = useState(window.innerWidth);
  const [speed, setSpeed] = useState(1);
  const [duration, setDuration] = useState(null);
  const [seeking, setSeeking] = useState(false);
  const [jumpTo, setJumpTo] = useState("");
  const [showControls, setShowControl] = useState(false);
  const [isMute, setIsMute] = useState(false);
  const [activeFilter, setActiveFilter] = useState("all");
  const playerRef = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();
  const [eventStrings, setEventStrings] = useState([]);
  const [transformedStrings, setTransformedStrings] = useState();
  const [isNotifying, setIsNotifying] = useState(false);
  const [isCompleting, setIsCompleting] = useState(false);
  const listRef = useRef(null);
  const [searchStringValue, setSearchStringValue] = useState("");
  const [upcomingNextIndex, setUpcomingNextIndex] = useState(-1);
  const { width } = useWindowDimensions();
  const [scrollPosition, setScrollPosition] = useState(0);
  const [searchMatchIndexes, setSearchMatchIndexes] = useState([]);
  const [currentSearchIndex, setCurrentSearchIndex] = useState(-1);

  const isMobile = width < 850;
  const isYoutubeUrl = () => {
    if (matchDetails?.youtube_videos[0]?.url) {
      const hostname = new URL(matchDetails?.youtube_videos[0]?.url).hostname;
      return hostname.includes("youtube.com");
    }
    return false;
  };

  const handleSeekMouseDown = (e) => {
    setSeeking(true);
  };

  const handleSeekChange = (e) => {
    UpdateVideoTime(parseFloat(e.target.value));
  };

  const handleSeekMouseUp = (e) => {
    setSeeking(false);
    playerRef.current.seekTo(parseFloat(e.target.value));
  };

  // limit toast to a max of 3
  const { toasts } = useToasterStore();

  const TOAST_LIMIT = 3;

  useEffect(() => {
    toasts
      .filter((t) => t.visible)
      .filter((_, i) => i >= TOAST_LIMIT)
      .forEach((t) => toast.dismiss(t.id));
  }, [toasts]);

  const full = () => {
    if (screenfull.isEnabled) {
      screenfull.request(findDOMNode(playerRef.current));
    }
  };

  // Fetch reviewer strings first
  const { data: reviewStrings } = useQuery({
    queryKey: ["getReviewerStrings"],
    queryFn: () =>
      getReviewerFeedbackStrings({
        matchId,
        token,
        reviewerId: reviewerId ?? matchAnalystId,
        analystId: matchAnalystId,
      }),
  });

  useEffect(() => {
    // Mixpanel – screen entry
    trackEvent().track('entered_review_screen', { match_id: matchId });
  }, [matchId]);

  useEffect(() => {
    const initializeEventStrings = async () => {
      try {
        // Fetch match strings first
        const matchResult = await fetchMatchStringById(
          Number(matchId),
          "",
          token
        );

        if (!matchResult?.temp_string) {
          toast.error("No strings found for this match");
          return;
        }

        // Parse match strings
        const matchStrings = matchResult.temp_string
          .split(",")
          .map((str) => str.trim())
          .filter((str) => str.length > 0);

        // Create a map from review strings for quick lookup
        const reviewStatusMap = new Map();

        if (
          reviewStrings &&
          reviewStrings.string_details &&
          Object.keys(reviewStrings.string_details).length > 0
        ) {
          // Review strings are already in full format (not nested)
          Object.entries(reviewStrings.string_details).forEach(
            ([fullString, details]) => {
              reviewStatusMap.set(fullString, {
                status: details.string_status,
                comments: details.comments,
              });
            }
          );
        }

        console.log(reviewStatusMap, "REVIEW STSTUAS MAP");

        // Map match strings with review status
        const mappedStrings = matchStrings.map((str, index) => {
          const reviewData = reviewStatusMap.get(str);

          let status;
          let error = null;
          let isFixed = false;

          if (reviewData !== undefined) {
            // Use review status if available
            if (reviewData.status === 0) {
              status = "error";
              error = reviewData.comments;
            } else if (reviewData.status === 1) {
              // Treat "fixed" status as upcoming for re-review
              status = "upcoming";
              isFixed = true;
              error = reviewData.comments;
            } else if (reviewData.status === 2) {
              status = "reviewed";
            } else {
              // Unknown status, treat as upcoming
              status = "upcoming";
            }
          } else {
            // No review data, use default logic
            status = "upcoming";
          }

          return {
            id: uuidv4(),
            value: str,
            status,
            isFixed: isFixed || false,
            error,
          };
        });

        // Find first upcoming string (includes new strings and fixed errors) and set as current
        const firstPendingIndex = mappedStrings.findIndex(
          (s) => s.status === "upcoming"
        );

        if (firstPendingIndex !== -1) {
          // There are still strings to review (either new or fixed)
          mappedStrings[firstPendingIndex].status = "current";
        }
        // If no upcoming strings found, don't set any as current
        // This means all strings are either "reviewed" or "error" and review is complete

        setEventStrings(mappedStrings);
      } catch (error) {
        console.error("Failed to initialize event strings", error);
        toast.error("Failed to load match data");
      }
    };

    if (matchId && analystId && token) {
      initializeEventStrings();
    }
  }, [matchId, analystId, token, reviewStrings]);

  console.log(eventStrings, "CHECK");

  const handleMute = () => {
    setIsMute(!isMute);
  };

  const cache = useRef(
    new CellMeasurerCache({
      fixedWidth: true,
      defaultHeight: 120,
    })
  );

  useEffect(() => {
    cache.current.clearAll();
    if (listRef.current) {
      listRef.current.forceUpdateGrid();
      // listRef.current.recomputeRowHeights();
    }
  }, [eventStrings]);

  const jumpManually = (str) => {
    const jumpInputList = str?.split(":");
    if (jumpInputList.length < 3) {
      return;
    }
    const totalSecends =
      parseInt(jumpInputList[0]) * 60 * 60 +
      parseInt(jumpInputList[1]) * 60 +
      parseInt(jumpInputList[2]);
    playerRef.current.seekTo(parseFloat(totalSecends));
    setPlaying(true);
    setJumpTo("");
  };

  const updateTag = async (id, newValue) => {
    // Mixpanel – reviewer actions per status
    if (newValue.status === 'reviewed') {
      trackEvent().track('reviewer_marked_reviewed', { match_id: matchId, string: newValue.value });
    } else if (newValue.status === 'error') {
      trackEvent().track('reviewer_marked_error', { match_id: matchId, string: newValue.value, error_comment: newValue.error ?? '' });
    } else if (newValue.status === 'current') {
      trackEvent().track('reviewer_edit_mode', { match_id: matchId, string: newValue.value });
    }

    setEventStrings((prev) => {
      const updated = prev.map((item) =>
        item.id === id ? { ...item, ...newValue } : item
      );

      const oldItem = prev.find((s) => s.id === id);

      // Check if this is an edit action (making a reviewed/error string current again)
      const isEditingToReview =
        (oldItem.status === "error" || oldItem.status === "reviewed") &&
        newValue.status === "current";

      // Check if this is editing an existing error comment
      const isEditingExistingError =
        oldItem.status === "error" && newValue.status === "error";

      // If we're just editing to review again or editing error comment, don't advance
      if (isEditingToReview || isEditingExistingError) {
        // Clear any other "current" strings before setting this one
        if (isEditingToReview) {
          return updated.map((item) =>
            item.id === id
              ? item // Keep the newly current item
              : item.status === "current"
                ? { ...item, status: "upcoming" } // Revert other current items to upcoming
                : item
          );
        }
        return updated;
      }

      // Only advance to next string if marking as reviewed or error (completing review)
      if (newValue.status === "reviewed" || newValue.status === "error") {
        const currentIndex = updated.findIndex((s) => s.id === id);
        for (let i = currentIndex + 1; i < updated.length; i++) {
          if (updated[i].status === "upcoming") {
            updated[i].status = "current";
            break;
          }
        }
      }

      return updated;
    });

    try {
      // Only save to backend if we're actually reviewing (not just switching to edit mode)
      if (newValue.status !== "current") {
        const string_status =
          newValue.status === "error" ? 0 : newValue.status === "fixed" ? 1 : 2;

        const comments = newValue.error ? newValue.error : "";

        await saveReviewerFeedback({
          token,
          body: {
            match_id: Number(matchId),
            reviewer_id: reviewerId ?? analystId,
            string_details: [
              {
                string: newValue.value,
                string_status,
                comments,
              },
            ],
          },
        });

        toast.success("Feedback saved!");
      }
    } catch (err) {
      console.log(err);
      toast.error("Failed to save feedback.");
    }
  };

  useEffect(() => {
    const index = filteredData.findIndex((item) => item.status === "current");

    if (index !== -1 && listRef.current) {
      requestAnimationFrame(() => {
        cache.current.clear(index);
        // listRef.current.scrollToRow(index);
        setUpcomingNextIndex(index);
      });
    }
  }, [eventStrings]);

  const getNextCurrentIndex = () => {
    return eventStrings.findIndex((item) => item.status === "current");
  };

  const focusNextError = () => {
    const currentIndex = eventStrings.findIndex((e) => e.status === "current");
    if (currentIndex === -1) {
      toast.error("No active item to mark error");
      return;
    }
    setEventStrings((prev) =>
      prev.map((it, i) =>
        i === currentIndex
          ? { ...it, _openErrorInput: true }
          : { ...it, _openErrorInput: false }
      )
    );
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!playerRef.current) return;

      // system shortcuts
      // eslint-disable-next-line default-case
      switch (e.key) {
        case " ":
          e.preventDefault();
          props.SetVideoControl(!props.videoControl);
          return;

        case "ArrowRight":
          playerRef.current.seekTo(props.videoTime + 5);
          return;

        case "ArrowLeft":
          playerRef.current.seekTo(props.videoTime - 5);
          return;

        case "e":
        case "E":
          e.preventDefault();
          focusNextError();
          return;

        case "m":
        case "M":
          setIsMute((prev) => !prev);
          return;
      }

      const currentItem = eventStrings.find((s) => s.status === "current");
      if (!currentItem) return;

      if (
        (e.key === "n" || e.key === "N") &&
        searchStringValue === "" &&
        (activeFilter === "all" ||
          activeFilter === "pending" ||
          activeFilter === "fixed")
      ) {
        updateTag(currentItem.id, {
          value: currentItem.value,
          status: "reviewed",
          error: null,
        });

        // requestAnimationFrame(() => {
        //   const nextIndex = getNextCurrentIndex();
        //   if (nextIndex !== -1 && activeFilter !== "pending") {
        //     // cache.current.clear(nextIndex);
        //     // listRef.current.recomputeRowHeights(nextIndex);
        //     listRef.current.scrollToRow(nextIndex);
        //   }
        // });

        toast.success("Marked as Reviewed");
        return;
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [
    props.videoControl,
    props.videoTime,
    eventStrings,
    searchStringValue,
    activeFilter,
  ]);

  const handleErrorInputToggle = (index) => {
    cache.current.clear(index);
    if (listRef.current) {
      listRef.current.forceUpdateGrid();
    }
  };

  const handleDeployToTMS = async () => {
    // Mixpanel
    trackEvent().track('reviewer_deploy_to_tms', { match_id: matchId });
    try {
      setIsCompleting(true);

      const res = await updateMatchStatus({
        match_id: Number(matchId),
        match_status: 7,
        token,
      });

      if (res?.response_data?.is_success) {
        toast.success("Match Status Updated!!");
      }
    } catch (err) {
      console.log(err);
      toast.error("Failed to Update Match Status!!");
    } finally {
      setIsCompleting(false);
    }
  };

  const handleNotifyAnalysts = async () => {
    // Mixpanel
    trackEvent().track('reviewer_notify_analysts', { match_id: matchId });
    try {
      setIsNotifying(true);

      const res = await updateMatchStatus({
        match_id: Number(matchId),
        match_status: 9,
        reviewer_id: Number(analystId), // logged in user
        token,
      });

      if (res?.response_data?.is_success) {
        toast.success("Match Status Updated!!");
      }
    } catch (err) {
      console.log(err);
      toast.error("Failed to Update Match Status!!");
    } finally {
      setIsNotifying(false);
    }
  };

  const warningCount = transformedStrings?.filter(
    (item) => item.type === "warning"
  ).length;

  const errorCount = transformedStrings?.filter(
    (item) => item.type === "error"
  ).length;

  const formatTimeFromSeconds = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hrs.toString().padStart(2, "0")}:${mins
      .toString()
      .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  const details = all_matches?.find((m) => {
    return m.id.toString() === matchId;
  });

  const filteredData = useMemo(() => {
    if (!eventStrings) return [];

    return eventStrings.filter((item) => {
      // Handle filter logic
      if (activeFilter === "all") return true;
      if (activeFilter === "pending") {
        return item.status === "upcoming" || item.status === "current";
      }
      if (activeFilter === "fixed") {
        return item.isFixed === true;
      }
      return item.status === activeFilter;
    });
  }, [eventStrings, activeFilter]);

  // clear if filter changes
  useEffect(() => {
    setCurrentSearchIndex(-1);
    setSearchMatchIndexes([]);
  }, [activeFilter]);
  // search and filter but dont filter out the main array just being used fpor traversal
  useEffect(() => {
    if (!searchStringValue || !filteredData?.length) {
      setSearchMatchIndexes([]);
      setCurrentSearchIndex(-1);
      return;
    }

    const search = searchStringValue.toLowerCase();

    const matches = filteredData.reduce((acc, item, index) => {
      const parts = item.value?.split("-") || [];
      const timestamp = (parts[6] || "").toLowerCase();

      if (
        item.value.toLowerCase().includes(search) ||
        timestamp.includes(search)
      ) {
        acc.push(index);
      }

      return acc;
    }, []);

    setSearchMatchIndexes(matches);
    setCurrentSearchIndex(matches.length ? matches[0] : -1);
  }, [searchStringValue, filteredData]);

  useEffect(() => {
    if (currentSearchIndex !== -1 && listRef.current) {
      listRef.current.scrollToRow(currentSearchIndex);
    }
  }, [currentSearchIndex]);

  // scrollToIndex from <list/> being used
  const goToNextSearchMatch = () => {
    if (!searchMatchIndexes.length) return;
    const currentPos = searchMatchIndexes.indexOf(currentSearchIndex);
    const nextPos = (currentPos + 1) % searchMatchIndexes.length;
    setCurrentSearchIndex(searchMatchIndexes[nextPos]);
  };

  const goToPrevSearchMatch = () => {
    if (!searchMatchIndexes.length) return;
    const currentPos = searchMatchIndexes.indexOf(currentSearchIndex);
    const prevPos =
      (currentPos - 1 + searchMatchIndexes.length) % searchMatchIndexes.length;
    setCurrentSearchIndex(searchMatchIndexes[prevPos]);
  };

  if (isLoading) {
    return (
      <Stack
        style={{
          width: "100%",
          height: "100%",
          zIndex: 10,
          backgroundColor: "#fff",
          position: "absolute",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Logo />
        <Typography style={{ color: "#131313", fontFamily: "Source Sans 3" }}>
          loading setup...
        </Typography>
      </Stack>
    );
  }

  return (
    <div>
      {/* Header */}
      <div style={styles.header.container}>
        <div style={styles.header.side}>
          <IconButton
            onClick={() => {
              history.goBack();
            }}
            size="small"
            sx={{ background: "#e1e1e1", mr: 1 }}
          >
            <ArrowBack fontSize="16px" />
          </IconButton>
        </div>
        <div style={styles.header.center}>
          <span style={styles.header.score}>{matchId}</span>
          <span style={styles.header.matchInfo}>
            {matchDetails?.team_a_details?.name} vs{" "}
            {matchDetails?.team_b_details?.name}
          </span>
        </div>
      </div>

      {/* Cards */}
      <div style={styles.cardContainer}>
        {/* Card 1 */}
        <div style={styles.card1.card}>
          <div style={styles.card1.content}>
            <div style={{ ...styles.card1.team, alignItems: "flex-start" }}>
              <div style={styles.card1.teamBoxA}>
                <div style={styles.card1.label}>Team A</div>
              </div>
              <div style={styles.card1.teamNameText}>
                {matchDetails?.team_a_details?.name}
              </div>
            </div>

            <div style={{ ...styles.card1.team, alignItems: "flex-end" }}>
              <div style={styles.card1.teamBoxB}>
                <div style={styles.card1.label}>Team B</div>
              </div>
              <div style={styles.card1.teamNameText}>
                {matchDetails?.team_b_details?.name}
              </div>
            </div>
          </div>
        </div>

        {/* Card 2 */}
        <div style={styles.card2.card}>
          <div style={styles.card2.content}>
            <div style={styles.card2.box}>
              <div style={styles.card2.id}>
                {matchDetails?.analyst_details[0]?.id}
              </div>
            </div>

            <div style={styles.card2.textRight}>
              <div style={styles.card2.name}>
                {matchDetails?.analyst_details[0]?.name}
              </div>
              <div style={styles.card2.label}>Analyst ID & Name</div>
            </div>
          </div>
        </div>

        {/* Card 3 */}
        <div style={styles.card3.card}>
          <div style={styles.card3.row}>
            <div style={styles.card3.title}>Elapsed time</div>

            <div style={styles.card3.timeProgressWrapper}>
              <div style={styles.card3.time}>
                {formatTimeFromSeconds(details.analysis_tat) || "00:00:00"}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style={styles.urlCard.wrapper}>
        <div style={styles.urlCard.row}>
          <div style={styles.urlCard.label}>Load Custom Video URL</div>
          <div style={styles.urlCard.inputGroup}>
            <input
              type="text"
              placeholder="Paste match video url.."
              style={styles.urlCard.input}
            />
            <button style={styles.urlCard.button}>
              <FaSearch color="#fff" size={12} />
            </button>
          </div>
        </div>
      </div>

      <div
        style={{
          width: isMobile && "100%",
          display: "flex",
          flexDirection: isMobile ? "column " : "row",
          gap: "5px",
          margin: "1rem",
        }}
      >
        <div
          style={{
            width: isMobile ? "100%" : "75%",
          }}
        >
          <div
            style={{
              width: "100%",
            }}
          >
            {/* <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginTop: "1rem",
              }}
            >
              <Typography
                style={{ fontSize: 18, fontWeight: "600", marginBottom: 12 }}
              >
                Event Clip Tracker
              </Typography>
              <Typography
                style={{ fontSize: 12, color: "#FF5A1F", marginBottom: 12 }}
              >
                Verify Event String with video clip..
              </Typography>
            </div> */}
            <Stack style={styles.videoContainer}>
              <VideoPlayer
                cref={playerRef}
                url={matchDetails?.youtube_videos[0]?.url}
                controls={showControls}
                played={props.videoTime}
                muted={isMute}
                onProgress={(e) => {
                  !seeking && UpdateVideoTime(e);
                }}
                playing={props.videoControl}
                onPause={() => {
                  SetVideoControl(false);
                }}
                onEnded={() => {
                  SetVideoControl(false);
                }}
                onPlay={() => {
                  SetVideoControl(true);
                }}
                onReady={() => {
                  setReady(true);
                }}
                playbackRate={speed}
                onDuration={(t) => {
                  setDuration(t);
                }}
              />

              {ready && !isYoutubeUrl() && (
                <Stack style={styles.videoTimeline}>
                  <input
                    type="range"
                    value={props.videoTime}
                    style={{ width: "100%", borderWidth: 0 }}
                    min={0}
                    max={duration}
                    onMouseDown={handleSeekMouseDown}
                    onChange={handleSeekChange}
                    onMouseUp={handleSeekMouseUp}
                  />
                  <TouchableOpacity
                    onPress={full}
                    style={{
                      width: 2 * (layoutWidth / 100),
                      height: 2 * (layoutWidth / 100),
                      borderRadius: 5,
                      justifyContent: "center",
                      alignItems: "center",
                      boxShadow: "0px 2px 6px #00000020",
                      backgroundColor: "#e1e1e1",
                      marginRight: 10,
                      marginLeft: 3,
                    }}
                  >
                    <AiOutlineFullscreen
                      color="#131313"
                      size={layoutWidth / 100}
                    />
                  </TouchableOpacity>
                  <TouchableOpacity
                    onPress={handleMute}
                    style={{
                      width: 2 * (layoutWidth / 100),
                      height: 2 * (layoutWidth / 100),
                      borderRadius: 5,
                      justifyContent: "center",
                      alignItems: "center",
                      boxShadow: "0px 2px 6px #00000020",
                      backgroundColor: "#e1e1e1",
                      marginRight: 10,
                      marginLeft: 3,
                    }}
                  >
                    {isMute ? (
                      <IoMdVolumeOff color="#131313" size={layoutWidth / 100} />
                    ) : (
                      <IoMdVolumeHigh
                        color="#131313"
                        size={layoutWidth / 100}
                      />
                    )}
                  </TouchableOpacity>
                </Stack>
              )}

              {ready && (
                <Stack style={styles.controlContainer}>
                  <Stack style={styles.leftControl}>
                    <div>
                      <FaStopwatch
                        size={"1rem"}
                        color="rgba(170, 173, 177, 1)"
                      />
                      <Typography
                        style={{
                          fontFamily: "Poppins",
                          fontSize: "13px",
                          fontWeight: "600",
                          color: "rgba(9, 16, 29, 1)",
                          marginStart: "0.5rem",
                        }}
                      >
                        Jump To :
                      </Typography>
                    </div>
                    <Stack
                      style={{ flexDirection: "row", alignItems: "center" }}
                    >
                      <TextInput
                        style={{
                          maxWidth: "5rem",
                          fontSize: "10px",
                          border: "0.715px solid rgba(144, 152, 161, 0.20) ",
                          borderRadius: "3px",
                          color: "rgba(33, 33, 46, 0.50)",
                          paddingVertical: "0.8rem",
                          outline: "none",
                          textAlign: "center",
                          marginStart: "0.8rem",
                        }}
                        onChangeText={setJumpTo}
                        defaultValue={jumpTo}
                        placeholder="HH:MM:SS"
                      />
                      <TouchableOpacity
                        disabled={jumpTo === ""}
                        onPress={() => jumpManually(jumpTo)}
                        style={{
                          width: "1.4rem",
                          height: "1.4rem",
                          marginStart: "0.5rem",
                          borderRadius: 5,
                          justifyContent: "center",
                          alignItems: "center",
                          borderColor: "#111",
                          borderWidth: 1,
                        }}
                      >
                        <FaArrowRight size={10} />
                      </TouchableOpacity>
                    </Stack>
                  </Stack>
                  {!isYoutubeUrl() ? (
                    <>
                      <Stack style={styles.middleControl}>
                        <Duration seconds={props.videoTime} />

                        <TouchableOpacity
                          onPress={() => {
                            props.SetVideoControl(!props.videoControl);
                          }}
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            backgroundColor: "rgba(232, 108, 0, 1)",
                            paddingHorizontal: "2rem",
                            paddingVertical: "1rem",
                            borderRadius: "8px",
                          }}
                        >
                          <Stack
                            style={{
                              width: "1rem",
                              height: "1rem",
                              borderRadius: "2rem",
                              justifyContent: "center",
                              alignItems: "center",
                              backgroundColor: "#fff",
                            }}
                          >
                            {!props.videoControl ? (
                              <FaPlay
                                color="rgba(232, 108, 0, 1)"
                                size={"0.5rem"}
                              />
                            ) : (
                              <FaPause
                                color="rgba(232, 108, 0, 1)"
                                size={"0.5rem"}
                              />
                            )}
                          </Stack>

                          <Typography
                            style={{
                              fontsize: "18px",
                              color: "#fff",
                              fontWeight: "600",
                              marginStart: "0.6rem",
                            }}
                          >
                            {!props.videoControl ? "Play Video" : "Pause Video"}
                          </Typography>
                        </TouchableOpacity>
                      </Stack>

                      <Stack style={styles.rightControl}>
                        <Typography
                          style={{
                            fontFamily: "Poppins",
                            fontSize: "10px",
                            fontWeight: "600",
                            color: "rgba(33, 33, 46, 0.5)",
                          }}
                        >
                          Playback Speed:
                        </Typography>
                        <Stack
                          style={{
                            marginStart: "1rem",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {[0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75].map((s) => (
                            <TouchableOpacity
                              key={s}
                              onPress={() => setSpeed(s)}
                              style={{
                                width: "2.5rem",
                                height: "2.5rem",
                                borderRadius: 5,
                                justifyContent: "center",
                                alignItems: "center",
                                margin: 5,
                                border:
                                  "0.715px solid rgba(144, 152, 161, 0.20) ",
                                backgroundColor:
                                  speed === s && "rgba(232, 108, 0, 1)",
                              }}
                            >
                              <Typography
                                style={{
                                  fontFamily: "Poppins",
                                  fontSize: "10px",
                                  fontWeight: "600",
                                  color:
                                    speed === s
                                      ? "#fff"
                                      : "rgba(33, 33, 46, 0.50)",
                                }}
                              >
                                {s}x
                              </Typography>
                            </TouchableOpacity>
                          ))}
                        </Stack>
                      </Stack>
                    </>
                  ) : null}
                </Stack>
              )}
            </Stack>
            <Stack
              style={{
                padding: 16,
                marginTop: "1rem",
                display: "flex",
                borderRadius: "0.2em",
                boxShadow: "0px 2px 6px 0px rgba(0, 0, 0, 0.22)",
                flexDirection: isMobile ? "column" : "row",
                justifyContent: "space-evenly",
                alignItems: "center",
              }}
            >
              {/* Event Details */}
              <Stack
                style={{
                  borderRight: "1px #E5E7EB solid",
                  padding: 12,
                  marginBottom: 14,
                  elevation: 2,
                }}
              >
                <Typography
                  style={{ fontSize: 18, fontWeight: "600", marginBottom: 12 }}
                >
                  Event Details
                </Typography>
                <InfoRow
                  label="Errors"
                  value={
                    eventStrings.filter((item) => item.status === "error")
                      ?.length || 0
                  }
                  bgColor="#fdecea"
                  textColor="#d32f2f"
                />

                <InfoRow
                  label="Reviewed"
                  value={
                    eventStrings.filter((item) => item.status === "reviewed")
                      ?.length || 0
                  }
                  bgColor="#e6f4ea"
                  textColor="#2e7d32"
                />

                <InfoRow
                  label="Pending Review"
                  value={
                    eventStrings.filter(
                      (item) =>
                        item.status === "upcoming" || item.status === "current"
                    )?.length || 0
                  }
                  bgColor="#fff4cc"
                  textColor="#f57c00"
                />
                <InfoRow
                  label="Total events tag"
                  value={eventStrings.length || 0}
                  bgColor="#333"
                  textColor="#fff"
                  bold
                />
                <Typography
                  style={{ marginTop: 10, fontSize: 12, color: "#d32f2f" }}
                >
                  Warning: Submission of the analysis is only permitted once all
                  errors and warnings have been addressed.
                </Typography>
              </Stack>

              {/* Action Buttons */}
              <Stack
                style={{
                  padding: 12,
                  marginBottom: 20,
                  elevation: 2,
                  width: isMobile ? "100%" : "33%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-around",
                  height: "-webkit-fill-available",
                }}
              >
                <div>
                  <TouchableOpacity
                    style={{
                      backgroundColor: "#F96302",
                      paddingVertical: 12,
                      borderRadius: 8,
                      alignItems: "center",
                      marginBottom: 12,
                      opacity:
                        isNotifying ||
                        eventStrings.filter((item) => item.status === "error")
                          ?.length === 0 ||
                        eventStrings.filter(
                          (item) =>
                            item.status === "upcoming" ||
                            item.status === "current"
                        )?.length > 0
                          ? 0.6
                          : 1,
                      cursor:
                        isNotifying ||
                        eventStrings.filter((item) => item.status === "error")
                          ?.length === 0 ||
                        eventStrings.filter(
                          (item) =>
                            item.status === "upcoming" ||
                            item.status === "current"
                        )?.length > 0
                          ? "not-allowed"
                          : "pointer",
                    }}
                    disabled={
                      isNotifying ||
                      eventStrings.filter((item) => item.status === "error")
                        ?.length === 0 ||
                      eventStrings.filter(
                        (item) =>
                          item.status === "upcoming" ||
                          item.status === "current"
                      )?.length > 0
                    }
                    onPress={handleNotifyAnalysts}
                  >
                    {isNotifying ? (
                      <CircularProgress size={18} sx={{ color: "#fff" }} />
                    ) : (
                      <Typography
                        style={{
                          color: "#fff",
                          fontWeight: "600",
                          fontSize: 16,
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <FaBell /> Notify Analysts
                      </Typography>
                    )}
                  </TouchableOpacity>
                  <TouchableOpacity
                    style={{
                      backgroundColor: "#007D48",
                      paddingVertical: 12,
                      borderRadius: 8,
                      alignItems: "center",
                      marginBottom: 12,
                      opacity:
                        isCompleting ||
                        eventStrings.filter((item) => item.status === "error")
                          ?.length ||
                        eventStrings.filter(
                          (item) =>
                            item.status === "upcoming" ||
                            item.status === "current"
                        )?.length
                          ? 0.6
                          : 1,
                      cursor:
                        isCompleting ||
                        eventStrings.filter((item) => item.status === "error")
                          ?.length ||
                        eventStrings.filter(
                          (item) =>
                            item.status === "upcoming" ||
                            item.status === "current"
                        )?.length
                          ? "not-allowed"
                          : "pointer",
                    }}
                    disabled={
                      isCompleting ||
                      eventStrings.filter((item) => item.status === "error")
                        ?.length ||
                      eventStrings.filter(
                        (item) =>
                          item.status === "upcoming" ||
                          item.status === "current"
                      )?.length
                    }
                    onPress={handleDeployToTMS}
                  >
                    {isCompleting ? (
                      <CircularProgress size={18} sx={{ color: "#fff" }} />
                    ) : (
                      <Typography
                        style={{
                          color: "#fff",
                          fontWeight: "600",
                          fontSize: 16,
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                        }}
                      >
                        Mark As Complete <FaArrowRight />
                      </Typography>
                    )}
                  </TouchableOpacity>
                </div>

                {eventStrings.filter((item) => item.status === "error")
                  ?.length > 0 ? (
                  <Typography
                    style={{ marginTop: 16, color: "#E02424", fontSize: 14 }}
                  >
                    Warning: Submission of the analysis is only permitted once
                    all errors and warnings have been addressed.
                  </Typography>
                ) : (
                  <Typography
                    style={{ marginTop: 16, color: "#2e7d32", fontSize: 14 }}
                  >
                    ✓ All unresolved issues have been addressed. You may now
                    proceed with the submission.
                  </Typography>
                )}
              </Stack>
            </Stack>
          </div>
        </div>
        <div
          style={{
            width: isMobile ? "100%" : "42%",
            // height: "60rem",
            height: isMobile && "80vh",
            overflow: isMobile ? "scroll" : "hidden",
            borderRadius: 8,
            backgroundColor: "#fff",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              margin: "1rem 1rem 0rem 1rem",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              <FilterButtons
                active={activeFilter}
                setActive={setActiveFilter}
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: 10,
                marginTop: 10,
                marginBottom: 16,
                alignItems: "baseline",
              }}
            >
              <div
                style={{
                  flex: 1,
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "#F3F4F6",
                  borderRadius: 6,
                  padding: "8px 12px",
                  border: "1px solid #E5E7EB",
                }}
              >
                <FaSearch color="#6B7280" size={14} />
                <input
                  value={searchStringValue}
                  onChange={(e) => setSearchStringValue(e.target.value)}
                  placeholder="Search String by Timestamp"
                  style={{
                    flex: 1,
                    marginLeft: 8,
                    border: "none",
                    outline: "none",
                    backgroundColor: "transparent",
                    fontSize: 16,
                    color: "#111827",
                  }}
                />
                {searchStringValue && searchMatchIndexes.length > 0 && (
                  <Stack
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <Typography
                      style={{
                        fontSize: 12,
                        paddingRight: "6px",
                        borderRight: "1px solid #6B7280",
                        color: "#555",
                      }}
                    >
                      {searchMatchIndexes.indexOf(currentSearchIndex) + 1} /{" "}
                      {searchMatchIndexes.length}
                    </Typography>

                    <FaAngleUp
                      onClick={goToNextSearchMatch}
                      style={{
                        cursor: "pointer",
                      }}
                      color="#6B7280"
                      size={16}
                    />

                    <FaAngleDown
                      style={{
                        cursor: "pointer",
                      }}
                      color="#6B7280"
                      size={16}
                      onClick={goToPrevSearchMatch}
                    />
                    <FaTimes
                      size={16}
                      color="#6B7280"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setSearchStringValue("");
                        if (listRef.current) {
                          listRef.current.scrollToPosition(scrollPosition);
                          // listRef.current.recomputeRowHeights(index);
                        }
                      }}
                    />
                  </Stack>
                )}
              </div>
              <LegendTooltipIcon />
            </div>
          </div>
          <div style={{ height: "87%" }}>
            {filteredData.length === 0 ? (
              <Stack
                style={{
                  padding: 16,
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                  width: "100%",
                }}
              >
                <Typography style={{ color: "gray", fontSize: 16 }}>
                  {`No ${activeFilter} strings found`}
                </Typography>
              </Stack>
            ) : (
              <AutoSizer>
                {({ width, height }) => (
                  <List
                    ref={listRef}
                    width={width}
                    onScroll={({ scrollTop }) => {
                      setScrollPosition(scrollTop);
                    }}
                    height={height}
                    scrollToIndex={
                      !searchStringValue && currentSearchIndex === -1
                        ? upcomingNextIndex
                        : undefined
                    }
                    style={{ padding: "10px" }}
                    scrollToAlignment="start"
                    deferredMeasurementCache={cache.current}
                    rowCount={filteredData.length}
                    rowHeight={cache.current.rowHeight}
                    rowRenderer={({ index, key, style, parent }) => {
                      const item = filteredData[index];

                      return (
                        <CellMeasurer
                          key={key}
                          cache={cache.current}
                          parent={parent}
                          rowIndex={index}
                          columnIndex={0}
                        >
                          <div style={style}>
                            <EditableTag
                              key={item.id}
                              openErrorInputExternally={
                                item._openErrorInput || false
                              }
                              searchValue={searchStringValue}
                              getNextCurrentIndex={getNextCurrentIndex}
                              activeFilter={activeFilter}
                              listRef={listRef}
                              text={item.value}
                              type={item.status}
                              error={item.error}
                              isFixed={item.isFixed}
                              index={index}
                              onChange={(newVal) => {
                                cache.current.clear(index);
                                updateTag(item.id, newVal);
                              }}
                              onErrorToggle={() =>
                                handleErrorInputToggle(index)
                              }
                              jumpManually={jumpManually}
                            />
                          </div>
                        </CellMeasurer>
                      );
                    }}
                  />
                )}
              </AutoSizer>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const InfoRow = ({ label, value, bgColor, textColor, bold }) => (
  <Stack
    style={{
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      marginVertical: 6,
      paddingBottom: 8,
      marginBottom: 8,
      borderBottom: "1px #E5E7EB solid",
    }}
  >
    <Typography
      style={{ fontSize: 16, color: "#333", fontWeight: bold ? "700" : "400" }}
    >
      {label}
    </Typography>
    <Stack
      style={{
        backgroundColor: bgColor,
        paddingHorizontal: 10,
        paddingVertical: 4,
        borderRadius: 6,
        minWidth: 40,
        alignItems: "center",
      }}
    >
      <Typography style={{ color: textColor, fontWeight: "600" }}>
        {value}
      </Typography>
    </Stack>
  </Stack>
);

const EditableTag = ({
  text,
  isFixed,
  onChange,
  error,
  getNextCurrentIndex,
  activeFilter,
  searchValue,
  listRef,
  openErrorInputExternally,
  type = "current",
  jumpManually,
  onErrorToggle,
}) => {
  const errorInputRef = useRef(null);
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState(text);
  const [showErrorInput, setShowErrorInput] = useState(false);
  const [errorText, setErrorText] = useState(error || "");

  useEffect(() => {
    if (showErrorInput && errorInputRef.current) {
      errorInputRef.current.focus();
    }
  }, [showErrorInput]);

  useEffect(() => {
    if (openErrorInputExternally) {
      setShowErrorInput(true);
      setErrorText(error || "");
    }
  }, [openErrorInputExternally]);

  const getEventFromString = (str) => {
    const parts = str?.split("-");
    if (parts?.length < 3) return null;
    const eventCode = `${parts?.[2]}-${parts?.[3]}`;
    return EVENT_MAP[eventCode] || null;
  };

  useEffect(() => {
    setValue(text);
  }, [text]);

  const highlightText = (text, search) => {
    if (!search) return text;

    const escaped = search.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const regex = new RegExp(`(${escaped})`, "ig");

    return text.split(regex).map((part, i) =>
      part.toLowerCase() === search.toLowerCase() ? (
        <span
          key={i}
          style={{
            backgroundColor: "#FFE58F",
            padding: "0 2px",
            borderRadius: 3,
            fontWeight: 600,
          }}
        >
          {part}
        </span>
      ) : (
        <span key={i}>{part}</span>
      )
    );
  };

  const handleClickedNoError = () => {
    setShowErrorInput(false);
    onChange({
      value,
      status: "reviewed",
      error: null,
    });
    // requestAnimationFrame(() => {
    //   const nextIndex = getNextCurrentIndex();
    //   if (nextIndex !== -1) {
    //     // cache.current.clear(nextIndex);
    //     // listRef.current.recomputeRowHeights(nextIndex);
    //     listRef.current.scrollToRow(nextIndex);
    //   }
    // });

    toast.success("Marked as reviewed");
  };

  const handleClickedError = () => {
    setShowErrorInput(true);
    setErrorText(error || "");
    if (onErrorToggle) onErrorToggle();
  };

  const handleSubmitError = () => {
    if (errorText.trim()) {
      onChange({
        value,
        status: "error",
        error: errorText,
        _openErrorInput: false,
      });
      setShowErrorInput(false);
      if (onErrorToggle) onErrorToggle();
    } else {
      toast.error("Please enter error description");
    }
  };

  const handleEditClick = () => {
    // Make this string current for editing
    onChange({
      value,
      status: "current",
      error,
    });
  };

  // const handleBlur = () => {
  //   setIsEditing(false);
  //   onChange({
  //     value,
  //     status: type,
  //     error,
  //   });
  // };

  const getStyleByType = (type, stringValue) => {
    const eventData = getEventFromString(stringValue);

    switch (type) {
      case "error":
        return {
          statusIcon: FaExclamationCircle,
          borderColor: "#DA1414",
          backgroundColor: "#FEEFEF",
          textColor: "#DA1414",
          iconColor: "#DA1414",
          badgeColor: "#f6e3e3ff",
          status: "Error",
        };
      case "current":
        if (eventData) {
          return {
            statusIcon: FaExclamationCircle,
            borderColor: eventData.color,
            backgroundColor: eventData.bgColor,
            textColor: "#000000",
            iconColor: eventData.color,
            eventLabel: eventData.label,
          };
        }
        return {
          statusIcon: FaExclamationCircle,
          borderColor: "#1A56DB",
          backgroundColor: "#E1EFFE",
          textColor: "#000000",
          iconColor: "#1A56DB",
        };
      case "fixed":
        return {
          statusIcon: FaCheckCircle,
          borderColor: "#287D3C",
          backgroundColor: "#EDF9F0",
          textColor: "#287D3C",
          iconColor: "#287D3C",
          badgeColor: "#d9f2ddff",
          status: "Fixed",
        };
      case "upcoming":
        if (eventData) {
          return {
            statusIcon: FaExclamationCircle,
            borderColor: eventData.color,
            backgroundColor: eventData.bgColor,
            textColor: eventData.color,
            iconColor: eventData.color,
            eventLabel: eventData.label,
          };
        }
        return {
          statusIcon: FaExclamationCircle,
          borderColor: "#9CA3AF",
          backgroundColor: "#E5E7EB",
          textColor: "#9CA3AF",
          iconColor: "#9CA3AF",
        };
      case "reviewed":
      default:
        if (eventData) {
          return {
            statusIcon: FaCheckCircle,
            borderColor: eventData.color,
            backgroundColor: eventData.bgColor,
            textColor: eventData.color,
            iconColor: eventData.color,
            eventLabel: eventData.label,
            status: "Reviewed",
            badgeColor: eventData.color + "22",
          };
        }
        return {
          statusIcon: FaCheckCircle,
          borderColor: "#287D3C",
          backgroundColor: "#EDF9F0",
          textColor: "#287D3C",
          badgeColor: "#d9f2ddff",
          iconColor: "#287D3C",
          status: "Reviewed",
        };
    }
  };

  const {
    borderColor,
    statusIcon,
    backgroundColor,
    badgeColor,
    textColor,
    iconColor,
    status,
  } = getStyleByType(type, value);

  const reduceTimeBySeconds = (timeString, secondsToReduce) => {
    const hours = parseInt(timeString.split(":")[0]);
    const minutes = parseInt(timeString.split(":")[1]);
    const seconds = parseInt(timeString.split(":")[2].split(".")[0]);

    let totalSeconds = hours * 3600 + minutes * 60 + seconds - secondsToReduce;
    if (totalSeconds < 0) totalSeconds = 0;

    const newHours = Math.floor(totalSeconds / 3600);
    const newMinutes = Math.floor((totalSeconds % 3600) / 60);
    const newSeconds = totalSeconds % 60;

    return `${newHours.toString().padStart(2, "0")}:${newMinutes
      .toString()
      .padStart(2, "0")}:${newSeconds.toString().padStart(2, "0")}`;
  };

  const jumpManuallyViaString = () => {
    jumpManually(reduceTimeBySeconds(value.split("-")[6], 2));
  };

  return (
    <Stack>
      {/* Tag Box */}
      <Stack
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: "5px",
          alignItems: "baseline",
          width: "100%",
          marginBottom: "5px",
          justifyContent: "center",
        }}
      >
        <Stack
          sx={{
            backgroundColor,
            borderRadius: "8px",
            paddingX: "12px",
            paddingY: "10px",
            border: `1px solid ${borderColor}`,
            minHeight: "30px",
            width: "100%",
            justifyContent: "space-between",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Typography
            style={{
              fontSize: 14,
              fontWeight: 400,
              color: textColor,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "1rem",
            }}
          >
            {React.createElement(statusIcon, { color: iconColor })}
            <span>{highlightText(value, searchValue)}</span>
          </Typography>

          {type !== "upcoming" && (
            <Stack
              style={{ flexDirection: "row", alignItems: "center", gap: 10 }}
            >
              <TouchableOpacity onPress={jumpManuallyViaString}>
                <FaVideo color={iconColor} />
              </TouchableOpacity>
              {isFixed && (
                <Stack
                  style={{
                    padding: "0.2rem 0.4rem",
                    alignItems: "center",
                    gap: 6,
                    borderWidth: "2px",
                    borderRadius: 5,
                    backgroundColor: "#287D3C",
                    borderColor: "#287D3C",
                  }}
                >
                  <Typography
                    style={{
                      color: "white",
                      fontSize: 12,
                    }}
                  >
                    Fixed
                  </Typography>
                </Stack>
              )}
              {/* Buttons only for CURRENT */}
              {type === "current" ? (
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                  <TouchableOpacity
                    style={{
                      paddingHorizontal: 8,
                      paddingVertical: 4,
                      borderRadius: 6,
                      borderWidth: 1,
                      borderColor: "#9B1C1C",
                      marginLeft: 6,
                      backgroundColor: "#FDE8E8",
                    }}
                    onPress={handleClickedError}
                  >
                    <Typography style={{ color: "#9B1C1C", fontSize: 12 }}>
                      Error
                    </Typography>
                  </TouchableOpacity>

                  <TouchableOpacity
                    style={{
                      paddingHorizontal: 8,
                      paddingVertical: 4,
                      borderRadius: 6,
                      borderWidth: 1,
                      borderColor: "#03543F",
                      marginLeft: 6,
                      backgroundColor: "#DEF7EC",
                    }}
                    onPress={handleClickedNoError}
                  >
                    <Typography style={{ color: "#03543F", fontSize: 12 }}>
                      No Error
                    </Typography>
                  </TouchableOpacity>
                </View>
              ) : (
                // Badge
                <Stack
                  style={{
                    flexDirection: "row",
                    padding: "0.2rem 0.4rem",
                    alignItems: "center",
                    gap: 6,
                    borderRadius: 5,
                    backgroundColor: badgeColor,
                  }}
                >
                  <Typography
                    style={{
                      color: iconColor,

                      fontSize: 12,
                    }}
                  >
                    {status}
                  </Typography>
                  <TouchableOpacity
                    onPress={handleEditClick}
                    style={{
                      padding: "0.2rem 0.4rem",
                      borderRadius: 4,
                    }}
                  >
                    <FaEdit color={iconColor} size={14} />
                  </TouchableOpacity>
                </Stack>
              )}
            </Stack>
          )}
        </Stack>
      </Stack>

      {/* ERROR INPUT BOX */}
      {showErrorInput && (
        <Stack
          style={{
            width: "94%",
            marginLeft: "auto",
            marginRight: "auto",
            marginBottom: 8,
            padding: 12,
            backgroundColor: "#FEF2F2",
            borderRadius: 8,
            border: "1px solid #FCA5A5",
          }}
        >
          <Typography
            style={{ fontSize: 12, color: "#991B1B", marginBottom: 8 }}
          >
            {error ? "Edit Error Comment:" : "Provide Error Details:"}
          </Typography>

          <Stack style={{ flexDirection: "row", alignItems: "center", gap: 8 }}>
            <TextInput
              ref={errorInputRef}
              style={{
                flex: 1,
                padding: 8,
                fontSize: 14,
                border: "1px solid #FCA5A5",
                borderRadius: 6,
                backgroundColor: "#fff",
                outline: "none",
              }}
              value={errorText}
              onKeyPress={(e) => {
                if (e.nativeEvent.key === "Enter") {
                  e.preventDefault();
                  handleSubmitError();
                }
              }}
              onChangeText={setErrorText}
              placeholder="Enter error description..."
            />

            <TouchableOpacity onPress={handleSubmitError}>
              <Typography
                style={{ color: "#03543F", fontSize: 14, fontWeight: "600" }}
              >
                <FaCheck />
              </Typography>
            </TouchableOpacity>

            <TouchableOpacity
              onPress={() => {
                setShowErrorInput(false);
                setErrorText(error || "");
                onChange({
                  value,
                  status: type,
                  error,
                  _openErrorInput: false,
                });
                // if (onErrorToggle) onErrorToggle();
              }}
            >
              <Typography
                style={{ color: "#DC2626", fontSize: 14, fontWeight: "600" }}
              >
                <FaTimes />
              </Typography>
            </TouchableOpacity>
          </Stack>
        </Stack>
      )}

      {/* ERROR COMMENT DISPLAY */}
      {error && (
        <Stack
          sx={{
            padding: "12px",
            backgroundColor: "#FEEFEF",
            color: "#DA1414",
            width: "95%",
            marginBottom: 1,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            marginLeft: "auto",
            marginRight: "auto",
            borderRadius: "8px",
          }}
        >
          <Typography
            style={{
              fontSize: 12,
              textAlign: "justify",
              marginRight: "6px",
            }}
          >
            <b>My Comment:</b> {error}
          </Typography>

          <TouchableOpacity
            onPress={() => {
              setShowErrorInput(true);
              setErrorText(error || "");
              if (onErrorToggle) onErrorToggle();
            }}
          >
            <FaEdit color="#DC2626" />
          </TouchableOpacity>
        </Stack>
      )}
    </Stack>
  );
};

const FilterButtons = ({ active, setActive }) => {
  const filters = [
    { label: "All", value: "all" },
    { label: "Reviewed", value: "reviewed" },
    { label: "Errors", value: "error" },
    { label: "Pending", value: "pending" },
    { label: "Fixed", value: "fixed" },
  ];

  return (
    <Stack style={{ flexDirection: "row", gap: 8, marginTop: 8 }}>
      {filters.map(({ label, value }) => {
        const isActive = active === value;

        return (
          <TouchableOpacity
            key={value}
            onPress={() => setActive(value)}
            style={{
              backgroundColor: isActive ? "#FF5A1F" : "#E5E7EB",
              borderRadius: 10,
              width: "90px",
              paddingHorizontal: 20,
              height: "40px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography
              style={{
                color: isActive ? "#fff" : "#000",
                fontSize: 14,
                fontWeight: "500",
              }}
            >
              {label}
            </Typography>
          </TouchableOpacity>
        );
      })}
    </Stack>
  );
};

const LegendTooltipIcon = () => {
  const grouped = {
    passing: [],
    shooting: [],
    defending: [],
    goalkeeping: [],
  };

  Object.entries(EVENT_MAP).forEach(([key, val]) => {
    grouped[val.group].push({ code: key, ...val });
  });

  return (
    <Tooltip
      arrow
      placement="left"
      title={
        <Box
          sx={{
            maxHeight: 260,
            overflowY: "auto",
            p: 1,
          }}
        >
          {/* PASSING */}
          <GroupLabel title="Passing (Green tones)" />
          {grouped.passing.map((item) => (
            <LegendRow key={item.code} item={item} />
          ))}

          {/* SHOOTING */}
          <GroupLabel title="Shooting (Red / Orange tones)" mt />

          {grouped.shooting.map((item) => (
            <LegendRow key={item.code} item={item} />
          ))}

          {/* DEFENDING */}
          <GroupLabel title="Defending (Blue tones)" mt />

          {grouped.defending.map((item) => (
            <LegendRow key={item.code} item={item} />
          ))}

          {/* GK */}
          <GroupLabel title="Goalkeeping (Purple / Amber)" mt />

          {grouped.goalkeeping.map((item) => (
            <LegendRow key={item.code} item={item} />
          ))}
        </Box>
      }
      componentsProps={{
        tooltip: {
          sx: {
            background: "#1F1F1F",
            borderRadius: "8px",
            maxWidth: 260,
            p: 1,
          },
        },
      }}
    >
      <IconButton size="small">
        <InfoOutlinedIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

const GroupLabel = ({ title, mt }) => (
  <Typography
    fontWeight={700}
    fontSize={12}
    sx={{ mt: mt ? 1 : 0.2, mb: 0.5, opacity: 0.9 }}
  >
    {title}
  </Typography>
);

const LegendRow = ({ item }) => (
  <Stack direction="row" alignItems="center" spacing={1} mb={0.4}>
    {/* Color box */}
    <Box
      sx={{
        width: 12,
        height: 12,
        borderRadius: "3px",
        background: item.color,
      }}
    />

    <Typography sx={{ width: 48, fontSize: 12, fontWeight: 600 }}>
      {item.code}
    </Typography>

    <Typography sx={{ fontSize: 12, opacity: 0.8 }}>{item.label}</Typography>
  </Stack>
);

const styles = {
  header: {
    container: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      height: 60,
      backgroundColor: "#fff",
      padding: "0 16px",
      boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
      zIndex: 10,
    },
    side: {
      width: 60,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    center: {
      flex: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: 8,
    },
    score: {
      color: "#1C64F2",
      fontWeight: "bold",
      fontSize: 16,
    },
    matchInfo: {
      color: "#667085",
      fontSize: 14,
    },
    logout: {
      color: "#FF5A1F",
      cursor: "pointer",
      fontWeight: "500",
    },
  },

  cardContainer: {
    display: "flex",
    gap: 10,
    padding: 20,
  },

  card1: {
    card: {
      flex: 1,
      height: 80,
      borderRadius: 8,
      backgroundColor: "#fff",
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    content: {
      display: "flex",
      width: "90%",
      justifyContent: "space-around",
    },
    team: {
      display: "flex",
      flexDirection: "column",
      gap: 12,
      width: "50%",
    },
    teamNameText: {
      fontWeight: "bold",
      fontSize: 14,
      textAlign: "center",
      marginBottom: 4,
    },
    teamBoxA: {
      backgroundColor: "#E7F5EC",
      padding: "4px 16px",
      borderRadius: 4,
      alignItems: "flex-start",
    },
    teamBoxB: {
      backgroundColor: "#E5F5FC",
      padding: "4px 16px",
      borderRadius: 4,
      alignItems: "flex-end",
    },
    label: {
      fontWeight: 400,
      textAlign: "center",
      fontSize: 14,
    },
  },

  card2: {
    card: {
      flex: 1,
      height: 80,
      borderRadius: 8,
      backgroundColor: "#fff",
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    content: {
      width: "90%",
      display: "flex",
      alignItems: "center",
      gap: 20,
    },
    box: {
      backgroundColor: "rgba(12, 157, 65, 0.1)",
      padding: "16px 10px",
      borderRadius: 8,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    id: {
      fontWeight: 500,
      fontSize: 18,
      color: "#000",
    },
    textRight: {
      display: "flex",
      flexDirection: "column",
      gap: 4,
    },
    name: {
      fontWeight: 600,
      color: "#000",
      fontSize: 16,
    },
    label: {
      fontSize: 13,
      color: "#394452",
    },
  },

  card3: {
    card: {
      flex: 1,
      height: 80,
      borderRadius: 8,
      backgroundColor: "#fff",
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    row: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      width: "90%",
      gap: 20,
    },
    title: {
      fontWeight: 600,
      color: "#000",
      fontSize: 18,
    },
    time: {
      color: "#FF5A1F",
      fontWeight: 500,
      fontSize: 16,
    },
    progressBar: {
      width: 60,
    },
    timeProgressWrapper: {
      display: "flex",
      alignItems: "center",
      gap: 20,
    },
  },

  urlCard: {
    wrapper: {
      padding: 10,
      borderRadius: 12,
      backgroundColor: "#fff",
      boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
      margin: "0 20px",
    },
    row: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: 20,
    },
    label: {
      fontWeight: 500,
      fontSize: 16,
      whiteSpace: "nowrap",
    },
    inputGroup: {
      display: "flex",
      border: "1px solid #E0E0E0",
      borderRadius: 8,
      overflow: "hidden",
      width: "30%",
    },
    input: {
      flex: 1,
      padding: "10px 12px",
      border: "none",
      outline: "none",
      fontSize: 14,
    },
    button: {
      backgroundColor: "#FF5A1F",
      border: "none",
      padding: "0 16px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
    },
  },

  container: {
    flex: 1,
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    backgroundColor: "#fff",
    marginBottom: "1rem",
  },
  videoContainer: {
    width: "100%",
    flex: "0.70",
    // paddingHorizontal: "1rem",
    borderRadius: "0.2em",
    boxShadow: "0px 2px 6px 0px rgba(0, 0, 0, 0.22)",
  },

  videoTimeline: {
    paddingTop: 5,
    paddingBottom: 5,
    width: "100%",
    paddingHorizontal: "1rem",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItem: "center",
  },

  controlContainer: {
    width: "96%",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "rgba(238, 242, 250, 1)",
    alignSelf: "center",
    paddingHorizontal: "0.8rem",
    paddingVertical: "1rem",
  },
  leftControl: {
    justifyContent: "flex-start",
    alignItems: "center",
    flexDirection: "column",
    gap: "2px",
  },
  middleControl: {
    alignItems: "center",
  },
  rightControl: {
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
  },
};

const mapStateToProps = (state) => {
  return {
    videoControl: state.control.videoControl,
    videoUrl: state.control.videoUrl,
    videoTime: state.control.videoTime,
    all_matches: state.match.all_matches,
    currentAction: state.control.currentAction,
    analysedString: state.control.analysedString,
    actionLog: state.control.actionLog,
    seekToTime: state.control.seekToTime,
    analystId: state.auth.analyst_id,
  };
};

export default connect(mapStateToProps, {
  UpdateVideoTime,
  LoadVideoUrl,
  SetVideoControl,
  SetControllerToggle,
  ClearSeekFlag,
})(ReviewPortal);
